import { CustomElement } from '@aurelia/runtime-html';
export const name = "callout-group";
export const template = "<template>\n  <div repeat.for=\"message of messages\">\n    <div class=\"alert alert-${message.type}\" role=\"alert\">\n      <span>${message.text}</span>\n    </div>\n  </div>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
